import { CommentInfo } from '@/models/forumAPI/CommentModel';

export interface CommentState {
  comments: { [key: string]: CommentInfo };
  isUpdatingForumCommentScore: { [key: string]: boolean }; // The key of this dictionary is the commentId.
}

const state: CommentState = {
  comments: {},
  isUpdatingForumCommentScore: {},
};

export default state;
